import { Loader2 } from 'lucide-react'
import { Navigate } from 'react-router-dom'
import { useGetUserSession } from '@/shared/hooks/api/auth'
import { resolveSettingsFullAccessRoute } from '@/shared/lib/readOnlyAccess'

type SettingsFullAccessRouteProps = {
  children: React.ReactNode
}

/** Redirects view-only users away from Organization / LLM settings. */
export function SettingsFullAccessRoute({
  children,
}: SettingsFullAccessRouteProps) {
  const { data: session, isFetched } = useGetUserSession()
  const routeState = resolveSettingsFullAccessRoute({
    isFetched,
    isReadOnly: session?.isReadOnly,
  })

  if (routeState === 'loading') {
    return (
      <div className='flex min-h-svh items-center justify-center'>
        <Loader2 className='size-8 animate-spin text-muted-foreground' />
      </div>
    )
  }

  if (routeState === 'redirect') {
    return <Navigate to='/settings/account' replace />
  }

  return <>{children}</>
}
